import { httpGet } from "../../../../../modules/Backend";
import AdobeSectionComboBox, { ISection } from "../../../../AdobeAriaLib/AdobeSectionComboBox";
import { useEffect, useState } from "react";

interface IFormSelectWrapper {
    value: string
    placeHolder: string
    label: string
    entityName: string
    required: boolean
    onChange: Function,
    isCreate: boolean
    labelClassName?: string
}

export default function FormSectionSelectWrapper({ value, placeHolder, label, entityName, required, onChange, isCreate, labelClassName }: IFormSelectWrapper) {
    const [sections, setSections] = useState<ISection[]>([])

    function handleChange(val : string){
        onChange(val)
    }

    function isDisabled() {

        if(isCreate) {
            return false;
        }

        if(!value) {
            return false;
        }

        let disabled = true
        sections.forEach(section => {
            section.options.forEach(option => {
                if(option.value === value){
                    disabled = false
                }
            })
        });
        return disabled
    }

    async function getData() {
        try {
            var result = await httpGet(`api/${entityName}/all`)
            if (result.data) {
                // Handle both camelCase and PascalCase property names
                const pascalCaseName = entityName!.charAt(0).toUpperCase() + entityName!.slice(1);
                const dataArray = result.data[entityName!] || result.data[pascalCaseName];
                if (dataArray) {
                    const sections = dataArray.map((x : any) =>{
                        // Handle both camelCase and PascalCase property names in the items
                        const text = x.text || x.Text;
                        const subTypes = x.subTypes || x.SubTypes || [];
                        const value = x.value || x.Value;
                        const parentOption = { text, value };
                        const subTypeOptions = subTypes.map((st: any) => ({
                            text: st.text || st.Text,
                            value: st.value || st.Value
                        }));
                        return {name: text, options: [parentOption].concat(subTypeOptions)} as ISection
                    })
                    setSections(sections)
                }
            }
        }
        catch (err) {
        }
    }

    useEffect(() => {
        getData()
    }, [])

    return (
        <div>
            <AdobeSectionComboBox
                value={value}
                placeHolder={placeHolder}
                label={label}
                labelVisible={true}
                sections={sections}
                required={required}
                onChangeSelect={handleChange}
                disabled={isDisabled()}
                labelClassName={labelClassName}
                selectionMode="single" />
        </div>
    )
}